import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.calendar": "Calendar",
      "nav.checklist": "Checklist",
      "nav.settings": "Settings",
      
      // Landing Page
      "landing.title": "HostBuddy",
      "landing.subtitle": "Professional Airbnb Property Management Platform",
      "landing.description": "Streamline your cleaning operations and guest communications with our comprehensive management system.",
      "landing.tagline": "Everything you need to manage your Airbnb properties efficiently",
      "landing.calendar.title": "Calendar Dashboard",
      "landing.calendar.description": "View all reservations and guest requirements in one unified calendar",
      "landing.checklist.title": "Cleaning Instructions",
      "landing.checklist.description": "Visual cleaning instructions with photos and detailed instructions",
      "landing.getStarted": "Get Started",
      "landing.learnMore": "Learn More",
      
      // Calendar
      "calendar.title": "Calendar Dashboard",
      "calendar.allProperties": "All Properties",
      "calendar.selectProperty": "Select Property",
      "calendar.noReservations": "No reservations found",
      "calendar.addNote": "Add Note",
      "calendar.viewNotes": "View Notes",
      "calendar.guestRequests": "Guest Requests",
      "calendar.checkIn": "Check-in",
      "calendar.checkOut": "Check-out",
      "calendar.guests": "Guests",
      
      // Checklist
      "checklist.title": "Cleaning Checklist",
      "checklist.selectProperty": "Select Property",
      "checklist.progress": "Progress",
      "checklist.completed": "Completed",
      "checklist.remaining": "Remaining",
      "checklist.finishCleaning": "Finish Cleaning",
      "checklist.uploadPhotos": "Upload Photos",
      "checklist.addNotes": "Add Notes",
      "checklist.chooseProperty": "Choose a property from the dropdown to view its cleaning checklist",
      "checklist.minutes": "min",
      "checklist.kitchen": "Kitchen",
      "checklist.bathroom": "Bathroom",
      "checklist.bedroom": "Bedroom",
      "checklist.livingRoom": "Living Room",
      "checklist.general": "General",
      "checklist.error": "Error Loading Checklist",
      
      // Common
      "common.loading": "Loading",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.edit": "Edit",
      "common.delete": "Delete",
      "common.confirm": "Confirm",
      "common.back": "Back",
      "common.next": "Next",
      "common.previous": "Previous",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.sort": "Sort",
      "common.refresh": "Refresh",
      
      // Messages
      "message.success": "Operation completed successfully",
      "message.error": "An error occurred",
      "message.noData": "No data available",
      "message.confirmDelete": "Are you sure you want to delete this item?",
      
      // Auth
      "auth.title": "Access Verification",
      "auth.subtitle": "Enter the last 4 digits of your phone number",
      "auth.codeLabel": "Verification Code",
      "auth.codePlaceholder": "Enter 4-digit code",
      "auth.verifyButton": "Verify Access",
      "auth.helpContact": "Need help? Contact your administrator",
      "auth.invalidCode": "Invalid verification code. Please try again.",
      "auth.verifying": "Verifying...",
      
      // Property Listings
      "listings.selectProperty": "Select a Property",
      "listings.chooseProperty": "Choose a property to view its calendar and guest requirements",
      "listings.viewCalendar": "View Calendar",
      "listings.bedrooms": "Bedrooms",
      "listings.guests": "Up to {{count}} Guests",
      "listings.noProperties": "No Properties Found",
      "listings.noPropertiesDesc": "No properties are currently configured.",
      
      // Cleaning Listings
      "cleaningListings.selectProperty": "Select a Property",
      "cleaningListings.chooseProperty": "Choose a property to view its cleaning Instructions",
      "cleaningListings.viewChecklist": "View Checklist",
      
      // Property Types
      "propertyType.apartment": "Apartment",
      "propertyType.house": "House",
      "propertyType.condo": "Condo",
      "propertyType.villa": "Villa",
      "propertyType.studio": "Studio"
    }
  },
  es: {
    translation: {
      // Navigation
      "nav.home": "Inicio",
      "nav.calendar": "Calendario",
      "nav.checklist": "Lista de Verificación",
      "nav.settings": "Configuración",
      
      // Landing Page
      "landing.title": "HostBuddy",
      "landing.subtitle": "Plataforma Profesional de Gestión de Propiedades Airbnb",
      "landing.description": "Optimiza tus operaciones de limpieza y comunicaciones con huéspedes con nuestro sistema integral de gestión.",
      "landing.tagline": "Todo lo que necesitas para gestionar tus propiedades de Airbnb de manera eficiente",
      "landing.calendar.title": "Panel de Calendario",
      "landing.calendar.description": "Ve todas las reservas y requisitos de huéspedes en un calendario unificado",
      "landing.checklist.title": "Instrucciones de limpieza",
      "landing.checklist.description": "Instrucciones de limpieza visuales con fotos e instrucciones detalladas",
      "landing.getStarted": "Comenzar",
      "landing.learnMore": "Saber Más",
      
      // Calendar
      "calendar.title": "Panel de Calendario",
      "calendar.allProperties": "Todas las Propiedades",
      "calendar.selectProperty": "Seleccionar Propiedad",
      "calendar.noReservations": "No se encontraron reservas",
      "calendar.addNote": "Agregar Nota",
      "calendar.viewNotes": "Ver Notas",
      "calendar.guestRequests": "Solicitudes de Huéspedes",
      "calendar.checkIn": "Entrada",
      "calendar.checkOut": "Salida",
      "calendar.guests": "Huéspedes",
      
      // Checklist
      "checklist.title": "Lista de Limpieza",
      "checklist.selectProperty": "Seleccionar Propiedad",
      "checklist.progress": "Progreso",
      "checklist.completed": "Completado",
      "checklist.remaining": "Restante",
      "checklist.finishCleaning": "Terminar Limpieza",
      "checklist.uploadPhotos": "Subir Fotos",
      "checklist.addNotes": "Agregar Notas",
      "checklist.chooseProperty": "Elige una propiedad del menú desplegable para ver su lista de limpieza",
      "checklist.minutes": "min",
      "checklist.kitchen": "Cocina",
      "checklist.bathroom": "Baño",
      "checklist.bedroom": "Dormitorio",
      "checklist.livingRoom": "Sala de Estar",
      "checklist.general": "General",
      "checklist.error": "Error al Cargar Lista",
      
      // Common
      "common.loading": "Cargando",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.edit": "Editar",
      "common.delete": "Eliminar",
      "common.confirm": "Confirmar",
      "common.back": "Atrás",
      "common.next": "Siguiente",
      "common.previous": "Anterior",
      "common.search": "Buscar",
      "common.filter": "Filtrar",
      "common.sort": "Ordenar",
      "common.refresh": "Actualizar",
      
      // Messages
      "message.success": "Operación completada exitosamente",
      "message.error": "Ocurrió un error",
      "message.noData": "No hay datos disponibles",
      "message.confirmDelete": "¿Estás seguro de que quieres eliminar este elemento?",
      
      // Auth
      "auth.title": "Verificación de Acceso",
      "auth.subtitle": "Ingresa los últimos 4 dígitos de tu número de teléfono.",
      "auth.codeLabel": "Código de Verificación",
      "auth.codePlaceholder": "Ingresa código de 4 dígitos",
      "auth.verifyButton": "Verificar Acceso",
      "auth.helpContact": "¿Necesitas ayuda? Contacta a tu administrador",
      "auth.invalidCode": "Código de verificación inválido. Por favor intenta de nuevo.",
      "auth.verifying": "Verificando...",
      
      // Property Listings
      "listings.selectProperty": "Seleccionar una Propiedad",
      "listings.chooseProperty": "Elige una propiedad para ver su calendario y gestionar reservas",
      "listings.viewCalendar": "Ver Calendario",
      "listings.bedrooms": "Dormitorios",
      "listings.guests": "Hasta {{count}} Huéspedes",
      "listings.noProperties": "No se Encontraron Propiedades",
      "listings.noPropertiesDesc": "No hay propiedades configuradas actualmente.",
      
      // Cleaning Listings
      "cleaningListings.selectProperty": "Seleccionar una Propiedad",
      "cleaningListings.chooseProperty": "Elige una propiedad para ver su lista de limpieza",
      "cleaningListings.viewChecklist": "Ver Lista de Verificación",
      
      // Property Types
      "propertyType.apartment": "Apartamento",
      "propertyType.house": "Casa",
      "propertyType.condo": "Condominio",
      "propertyType.villa": "Villa",
      "propertyType.studio": "Estudio"
    }
  },
  zh: {
    translation: {
      // Navigation
      "nav.home": "首页",
      "nav.calendar": "日历",
      "nav.checklist": "清洁清单",
      "nav.settings": "设置",
      
      // Landing Page
      "landing.title": "HostBuddy",
      "landing.subtitle": "专业的Airbnb房产管理平台",
      "landing.description": "通过我们的综合管理系统简化您的清洁操作和客人沟通。",
      "landing.tagline": "高效管理您的Airbnb房产所需的一切",
      "landing.calendar.title": "日历仪表板",
      "landing.calendar.description": "在统一的日历中查看所有预订和客人要求",
      "landing.checklist.title": "清洁说明",
      "landing.checklist.description": "带有照片和详细说明的可视化清洁清单",
      "landing.getStarted": "开始使用",
      "landing.learnMore": "了解更多",
      
      // Calendar
      "calendar.title": "日历仪表板",
      "calendar.allProperties": "所有房产",
      "calendar.selectProperty": "选择房产",
      "calendar.noReservations": "未找到预订",
      "calendar.addNote": "添加备注",
      "calendar.viewNotes": "查看备注",
      "calendar.guestRequests": "客人要求",
      "calendar.checkIn": "入住",
      "calendar.checkOut": "退房",
      "calendar.guests": "客人",
      
      // Checklist
      "checklist.title": "清洁清单",
      "checklist.selectProperty": "选择房产",
      "checklist.progress": "进度",
      "checklist.completed": "已完成",
      "checklist.remaining": "剩余",
      "checklist.finishCleaning": "完成清洁",
      "checklist.uploadPhotos": "上传照片",
      "checklist.addNotes": "添加备注",
      "checklist.chooseProperty": "从下拉菜单中选择一个房产来查看其清洁检查清单",
      "checklist.minutes": "分钟",
      "checklist.kitchen": "厨房",
      "checklist.bathroom": "浴室",
      "checklist.bedroom": "卧室",
      "checklist.livingRoom": "客厅",
      "checklist.general": "一般",
      "checklist.error": "加载清单时出错",
      
      // Common
      "common.loading": "加载中",
      "common.save": "保存",
      "common.cancel": "取消",
      "common.edit": "编辑",
      "common.delete": "删除",
      "common.confirm": "确认",
      "common.back": "返回",
      "common.next": "下一个",
      "common.previous": "上一个",
      "common.search": "搜索",
      "common.filter": "筛选",
      "common.sort": "排序",
      "common.refresh": "刷新",
      
      // Messages
      "message.success": "操作成功完成",
      "message.error": "发生错误",
      "message.noData": "无可用数据",
      "message.confirmDelete": "您确定要删除此项目吗？",
      
      // Auth
      "auth.title": "访问验证",
      "auth.subtitle": "请输入您电话号码的后四位",
      "auth.codeLabel": "验证码",
      "auth.codePlaceholder": "输入4位验证码",
      "auth.verifyButton": "验证访问",
      "auth.helpContact": "需要帮助？请联系您的管理员",
      "auth.invalidCode": "验证码无效，请重试。",
      "auth.verifying": "验证中...",
      
      // Property Listings
      "listings.selectProperty": "选择房产",
      "listings.chooseProperty": "选择一个房产来查看其日历并管理预订",
      "listings.viewCalendar": "查看日历",
      "listings.bedrooms": "卧室",
      "listings.guests": "最多{{count}}位客人",
      "listings.noProperties": "未找到房产",
      "listings.noPropertiesDesc": "当前没有配置的房产。",
      
      // Cleaning Listings
      "cleaningListings.selectProperty": "选择房产",
      "cleaningListings.chooseProperty": "选择一个房产来查看其清洁清单",
      "cleaningListings.viewChecklist": "查看检查清单",
      
      // Property Types
      "propertyType.apartment": "公寓",
      "propertyType.house": "房屋",
      "propertyType.condo": "公寓",
      "propertyType.villa": "别墅",
      "propertyType.studio": "工作室"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
